// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"384":"8cd3921d","613":"d228cc10","709":"afad1374","726":"88085f58"}[chunkId] + ".chunk.css";
};